module.exports = __webpack_public_path__ + "img/cosmetic_pants.a5794ae4.svg";